var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiotherapy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.206,18.639H45.54c-1.104,0-2,0.896-2,2s0.896,2,2,2h0.494v2.214H31.794c-1.104,0-2,0.896-2,2s0.896,2,2,2h0.493v22.946 c0,0.131,0.014,0.262,0.039,0.392c0.012,0.06,0.034,0.115,0.051,0.173c0.02,0.067,0.035,0.135,0.062,0.2 c0.028,0.069,0.067,0.131,0.103,0.196c0.027,0.049,0.049,0.101,0.081,0.148c0.074,0.11,0.157,0.213,0.251,0.307l6.253,6.253v13.895 h-1.113c-1.104,0-2,0.896-2,2s0.896,2,2,2h6.226c1.104,0,2-0.896,2-2s-0.896-2-2-2h-1.113V59.467l6.253-6.253 c0.094-0.093,0.177-0.196,0.251-0.307c0.032-0.047,0.053-0.099,0.081-0.148c0.036-0.065,0.075-0.127,0.103-0.196 c0.027-0.065,0.042-0.133,0.062-0.2c0.017-0.058,0.039-0.113,0.051-0.173c0.026-0.129,0.039-0.26,0.039-0.392v-1.452l2.906,2.906 v13.893H51.76c-1.104,0-2,0.896-2,2s0.896,2,2,2h6.226c1.104,0,2-0.896,2-2s-0.896-2-2-2h-1.112V53.253l6.253-6.252 c0.093-0.093,0.177-0.196,0.251-0.306c0.033-0.049,0.055-0.102,0.083-0.153c0.035-0.063,0.073-0.124,0.101-0.192 c0.027-0.066,0.043-0.134,0.063-0.202c0.017-0.057,0.039-0.112,0.051-0.171c0.026-0.129,0.039-0.26,0.039-0.392V22.639h0.493 c1.104,0,2-0.896,2-2S65.311,18.639,64.206,18.639z M59.713,44.757l-4.84,4.84l-4.84-4.84v-6.225h9.68V44.757z M41.127,55.811 l-4.84-4.84v-6.225h9.68v6.225L41.127,55.811z M45.967,28.853v11.893h-9.68V28.853H45.967z M59.713,34.532h-9.68v-5.679h0.427 c1.104,0,2-0.896,2-2s-0.896-2-2-2h-0.427v-2.214h9.68V34.532z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiotherapy);
export default __webpack_public_path__ + "static/media/physiotherapy.f36ec17c234fc8c2cac15a636a1070a9.svg";
export { ForwardRef as ReactComponent };